import { Injectable } from '@angular/core';

import {
  NoteAvatarAuthor,
  NoteAvatarInputValues,
  NoteAvatarUpdateStrategy,
} from '../note-avatar.types';

@Injectable()
export class RtNoteAvatarUpdate implements NoteAvatarUpdateStrategy {
  public getValues({
    author,
    triggered,
  }: {
    author: NoteAvatarAuthor;
    triggered: boolean | null;
  }): NoteAvatarInputValues {
    return {
      type: !triggered && !!author ? (author?.hasAvatar === false ? 'initials' : 'image') : 'icon',
      context: author?.hasAvatar ? (!!triggered ? 'candidate' : 'admin') : 'other',
      iconName: !triggered && !author ? 'person' : 'automated-actions',
      imageSrc: (!triggered && !author) || !!triggered ? null : (author?.photoThumbUrl ?? null),
      initials: author?.initials,
    };
  }
}
